import React from "react";
import Weather from "./Weather"
import "./Weather.css"
import "bootstrap/dist/css/bootstrap.css";


export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Aachen" />
        <br />
        <br />

        <footer>
          This project was coded by{" "}
          <a
            href="https://www.shecodes.io/graduates/54813-onyinyechi-chiagorom"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Onyi Chiagorom{" "}
          </a>{" "}
          and is open sourced on{" "}
          <a
            href="https://github.com/Onyi007/weather-react.git"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>{" "}
          and hosted on{" "}
          <a
            href="https://stalwart-dango-c942a3.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}